export enum Action {
  Manage = 'manage',
  Create = 'create',
  Read = 'read',
  Update = 'update',
  Delete = 'delete',
}

export enum Resource {
  Code = 'code',
  Event = 'event',
  Feed = 'feed',
  Log = 'log',
  Patient = 'patient',
  Camera = 'camera',
  EmergencyContact = 'emergency-contact',
  MonitoringHours = 'monitoring-hours',
  Router = 'router',
  Shift = 'shift',
  Users = 'users',
  ActivityEvent = 'activity-event',
  ActivityConfig = 'activity-config',
  MediaProvider = 'media-provider',
  VisionDebug = 'vision-debug',
}

export type PermissionString = `${Resource}:${Action}`;
